export default function EmptyState({ message }) {
  return <p className="empty-state">{message}</p>;
}
